import { AgGridReact } from '@ag-grid-community/react'
import GridActions from '@components/Base/GridActions/actions'
import { IReportDTO } from '@interfaces/report.interface'
import { Box, Typography } from '@mui/material'
import React from 'react'
export type IRVHeader = {
  reportData: IReportDTO
  gridReference: AgGridReact
}
const RVHeader: React.FC<IRVHeader> = ({ reportData, gridReference }) => {
  return (
    <Box display='grid' gridTemplateColumns='1fr auto' pb='8px'>
      <Box display='flex' gap={1}>
        <Typography fontWeight={600}>Portfolio:</Typography>
        <Typography fontWeight={600} className='rv-portfolio'>
          {reportData.portfolioName}
        </Typography>
      </Box>
      {/* <Box display='flex' gap={4}>
        <Box display='flex' gap={1}>
          <Typography fontWeight={600}>Portfolio:</Typography>
          <Typography fontWeight={600} className='rv-portfolio'>
            {reportData.portfolioName}
          </Typography>
        </Box>
        <Divider orientation='vertical' />
        <Box display='flex' gap={1}>
          <Typography>Benchmark:</Typography>
          <Typography className='rv-benchmarkName'>
            {reportData.benchmarkName}
          </Typography>
        </Box>
        <Divider orientation='vertical' />
        <Box display='flex' gap={1}>
          <Typography>Report Date Range:</Typography>
          <Typography className='rv-beginDate-endDate'>
            {dayjs(reportData.beginDate).format(DATE_FORMAT.TABLE_CHART)} -{' '}
            {dayjs(reportData.endDate).format(DATE_FORMAT.TABLE_CHART)}
          </Typography>
        </Box>
        <Divider orientation='vertical' />
        <Box display='flex' gap={1}>
          <Typography>Report ID:</Typography>
          <Typography className='rv-reportId'>{reportData.reportId}</Typography>
        </Box>
      </Box> */}
      <GridActions gridApiRef={gridReference} />
    </Box>
  )
}

export default RVHeader
